export enum Brands {
  GX = 'gx',
  LEADOKU = 'leadoku',
  INFINITE = 'infinite',
  BREACH = 'breach',
  ALURA = 'alura',
}
